import { Input, Select } from "antd";
import styled from "styled-components";
import { AiOutlineEdit } from "react-icons/ai";
import { FiTrash2 } from "react-icons/fi";
import MultiSelect from "../../components/MultiSelect";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 15px;
  padding-left: 8px;
  justify-content: ${(props) =>
    props.withSelectEvent ? "flex-start" : "space-between"};
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h1`
  font-family: Open Sans;
  font-weight: ${(props) => (props.sub ? "400" : "600")};
  font-size: 19.12px;
  line-height: 23.36px;
  color: #002244;
  text-align: center;
  align-self: start;
  gap: 8px;
  display: flex;
  margin-top: 6px;
`;
export const FlexContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const FieldWrapper = styled.div`
  width: 100%;
  position: relative;
  & > span {
    font-weight: 600;
    margin-bottom: -20px;
  }
`;

export const FieldWrapperWithoutWidthFull = styled.div`
  & > span {
    font-weight: 600;
    margin-bottom: -20px;
  }
`;

export const TrashIconContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const NewButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 16px;
  height: 34px;
  border-radius: 5px;
  gap: 8px;
  border: none;
  background-color: #002244;
  color: #ffffff;
  font-family: Open Sans;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    scale: 1.05;
  }
`;

export const InputTitle = styled.div`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 14px;
  color: rgba(58, 58, 60, 1);
  display: flex;
  align-items: center;
  justify-content: flex-start;

  & > p {
    color: red;
    margin: 0;
    margin-left: 4px;
  }

  & > span {
    color: gray;
    margin: 0;
    margin-left: 8px;
    font-weight: normal;
    font-size: 11px;
  }
`;

export const DescInputTitle = styled.div`
  font-family: Open Sans;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: gray;
  margin: 0;
  font-weight: normal;
  font-size: 12px;
`;

export const CardTextName = styled.div`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 14px;
  color: rgba(58, 58, 60, 1);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid rgba(218, 218, 218, 1);
  background: #f5f5f5;
  padding: 8px;
  border-radius: 8px;
  width: auto;

  & > span {
    margin: 0;
    font-weight: normal;
    margin-left: 3px;
  }
`;

export const SelectCustom = styled(Select)`
  width: 100%;

  .ant-select-selector {
    height: 48px !important;
    border-radius: 5px !important;
    border: 1px solid rgba(218, 218, 218, 1) !important;
    padding-left: 10px !important;
    padding-right: 40px !important;
    display: flex;
    align-items: center;
    font-family: Open Sans;
    font-weight: 400;
    font-size: 14px;
  }

  .ant-select-arrow {
    right: 10px;
    color: gray;
    font-size: 14px;
  }
`;

export const MultiSelectCustom = styled(Select)`
  width: 100%;

  .ant-select-selector {
    min-height: 48px !important;
    border-radius: 5px !important;
    border: 1px solid rgba(218, 218, 218, 1) !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    display: flex;
    align-items: center;
    font-family: Open Sans;
    font-weight: 400;
    font-size: 14px;
  }

  .ant-select-selection-overflow {
    gap: 4px;
  }

  .ant-select-selection-item {
    background-color: #e0e0e0 !important;
    border: 1px solid #b0b0b0 !important;
    color: #3a3a3c !important;
    font-family: Open Sans !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    border-radius: 4px !important;
    padding: 2px 8px 1px !important;
    margin: 2px 0 !important;
    display: flex !important;
    min-height: 28px !important;
    align-items: center !important;
  }

  .ant-select-selection-item-remove {
    color: #666 !important;
  }

  .ant-select-arrow {
    display: none !important;
  }
`;

export const Horizontal = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  width: 100%;

  /* Estilos para o dropdown do MultiSelect renderizado dentro do container */
  .ant-select-dropdown {
    .ant-select-item {
      padding: 8px 16px !important;
    }

    .ant-select-item-option {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .ant-select-item-option-content {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 8px;
    }

    .ant-select-item-option-state {
      flex-shrink: 0;
      margin-left: 12px;
    }
  }
`;

export const CustomInput = styled(Input)`
  width: 100%;
  height: 48px;
  border-radius: 5px;

  .ant-input {
    border: 1px solid var(--light-2, rgba(218, 218, 218, 1));
    padding-left: 10px;
    font-size: 14px;
  }

  &.ant-input-affix-wrapper {
    height: 48px;
    border-radius: 5px;
    border: 1px solid var(--light-2, rgba(218, 218, 218, 1));
    padding-left: 10px;
    font-size: 14px;

    .ant-input {
      height: 100%;
    }
  }

  .ant-input::placeholder {
    color: rgb(184, 191, 198);
    opacity: 1;
  }
`;

export const PreviewBackgroundContainer = styled.div`
  width: 100%;
  height: auto;
  min-height: 150px;
  border-radius: 8px;
  border: ${(props) =>
    props.hasImage
      ? "2px solid var(--light-2, rgba(218, 218, 218, 1))"
      : "2px dashed var(--light-2, rgba(218, 218, 218, 1))"};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-image: ${(props) =>
    props.hasImage ? "none" : "rgb(245, 245, 245)"};
`;

export const PreviewContainer = styled.div`
  max-width: ${(props) => (props.hasFile ? "500px" : "100%")};
  width: 100%;
  aspect-ratio: 210 / 297; /* A4 retrato */
  max-height: ${(props) => (props.hasFile ? " 707px" : "150px")};
  border-radius: 8px;
  border: ${(props) =>
    props.hasFile
      ? "2px solid var(--light-2, rgba(218, 218, 218, 1))"
      : "2px dashed var(--light-2, rgba(218, 218, 218, 1))"};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.hasFile ? "transparent" : "rgb(245, 245, 245)"};
  overflow: hidden;
`;

export const PreviewPdf = styled.iframe`
  width: 100% !important;
  height: 100% !important;
  border: none;
`;

export const PreviewLogoContainer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 2px solid var(--light-2, rgba(218, 218, 218, 1));
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
`;

export const UploadButton = styled.button`
  width: 100%;
  height: 100%;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 34, 68, 1);
  border: none;
  cursor: pointer;
  gap: 8px;
  display: flex;
  background: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ActionButton = styled.button`
  min-width: 110px;
  height: 34px;
  border-radius: 5px;
  padding: 8px 16px;
  margin-top: 50px;
  background: ${(props) => (props.save ? "#002244" : "rgba(254, 202, 202, 1)")};
  font-family: Open Sans;
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => (props.save ? "#FFFFFF" : "rgba(153, 27, 27, 1)")};
  border: none;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  gap: 5px;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  &:hover {
    scale: 1.05;
  }
  transition: background 0.3s; /* Added transition for smoother hover effect */
`;

export const ContainerButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
`;

export const Cards = styled.div`
  width: 335px;
  height: auto !important;
  border-radius: 8px;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 24px;
  padding-left: 16px;
  gap: 24px;
  border-width: 1px;
  border: 1px solid var(--light-2, rgba(235, 235, 240, 1));
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const LabelInfo = styled.div`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  color: rgba(58, 58, 60, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
`;

export const IconsDiv = styled.div`
  display: flex;
  gap: 16px;
`;

export const EditIcon = styled(AiOutlineEdit)`
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    transform: scale(1.3);
  }
`;

export const DeleteIcon = styled(FiTrash2)`
  cursor: pointer;
  transition: color 0.2s ease;
  color: red;

  &:hover {
    transform: scale(1.3);
  }
`;

export const ViewButton = styled.button`
  background: none;
  border: none;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  text-decoration: underline;
  color: rgba(17, 167, 217, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${(props) => props.cursor || "pointer"};
  &:hover {
    color: rgb(10, 112, 146);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding-left: 8px;
  padding-right: 8px;
`;

export const RemoveImageButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: black;
    font-size: 16px;
    line-height: 0;
  }

  &:hover {
    background: rgba(239, 68, 68, 1);
    span {
      color: white;
    }
  }
`;

export const AreaFilter = styled.div`
  padding: 0 8px 0 8px;
  margin-bottom: 34px;
`;

export const ElementTag = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const ContentTag = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const StatusTag = styled.span`
  color: ${(props) => props.colorText};
`;

export const PieChartContainer = styled.div`
  width: auto;
  height: auto;
  gap: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
`;

export const ChartCard = styled.div`
  background-color: rgba(225, 225, 225, 1);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${(props) => (props.bar ? "500px" : "400px")};
  margin-top: 30px;
  position: relative;
  flex-direction: column;
`;

export const ChartFiltersContainer = styled.div`
  width: fit-content;
  display: flex;
  gap: 16px;
`;

export const DashboardTableContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  align-items: center;
`;

export const TitleAndFilterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  gap: 20px;
`;

export const ExportButton = styled.button`
  height: 34px;
  border-radius: 5px;
  padding: 8px 16px;
  background: rgba(0, 34, 68, 1);
  font-family: Open Sans;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  border: none;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  gap: 5px;

  &:hover {
    scale: 1.05;
  }
`;
